module.exports = __webpack_public_path__ + "static/media/sample2@2x.8b6298c2.jpg";